import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ReviewPage } from '@/components/Review/ReviewPage'
import { reviewSearchSchema, withoutSearchDefaults } from '@/components/Review/search'
import { inPageSearch } from '@/lib/searchNavigation'

/**
 * Wiring only.
 *
 * The search schema and the default-pruning live beside the page, so imports
 * point one way (`components → routes`) and this file holds no logic to leave
 * untested.
 */
export const Route = createFileRoute('/_app/operations/review/')({
  validateSearch: reviewSearchSchema,
  component: ReviewRoute,
})

function ReviewRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <ReviewPage
      search={search}
      // Filtering and paging replace; opening a document pushes, so the back
      // button closes it. Either way the scroll stays.
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutSearchDefaults, next, options))
      }
    />
  )
}
